import { Button } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { HomeContext } from "../containers/Home";
import { getOperations } from "../services/api-server/operations";
import { getPhasesAndTasks } from "../services/api-server/phases";
import { useOperationStore } from "../stores/operationStore";
import { usePhaseStore } from "../stores/phaseStore";
import { useProjectStore } from "../stores/projectStore";
import { useTaskStore } from "../stores/taskStore";
import { TOperationData } from "../types/operation";
import { TPhaseData } from "../types/phase";
import { TTaskData } from "../types/task";
import { GetAntIcon } from "../utils/ant_icons";

const TaskSettingsButton = () => {
	const context: any = useContext(HomeContext);
	const navigate = useNavigate();

	const { project } = useProjectStore();
	const { operation } = useOperationStore();
	const { phase } = usePhaseStore();
	const { task } = useTaskStore();

	const [phaseRecord, setPhaseRecord] = useState<any>(null);

	type PhasesTasksResponse = {
		phase_data: TPhaseData[];
		task_data: Record<string, TTaskData[]>;
	};

	useEffect(() => {
		const fetchPhasesAndTasks = async () => {
			try {
				if (!phase) return;
				let filter = {};
				let operationId = null;
				if (project?.project_scope === "multi-asset") {
					operationId = operation?._id;
					filter = {
						project_id: project?._id,
					};
				} else {
					operationId = null;
					filter = {
						operation_code: operation?.operation_code,
					};
				}
				const { phase_data, task_data } = (await getPhasesAndTasks(
					context.currentTenantKey,
					filter,
					operationId
				)) as PhasesTasksResponse;

				const currentPhase = phase_data.find(
					(_phase: TPhaseData) => _phase._id === phase?._id
				);
				const currentPhaseTasks = task_data[phase?._id] || [];

				const currentTask = currentPhaseTasks.find(
					(_task: TTaskData) => _task._id === task?._id
				);

				const result = {
					...currentPhase,
					task_data: currentPhaseTasks,
					task: currentTask,
				};

				setPhaseRecord(result);
			} catch (error) {
				console.log("Error fetching phasesTasks: ", error);
			}
		};

		fetchPhasesAndTasks();
	}, [context.currentTenantKey, phase, task]);

	const handleNavigate = async () => {
		if (!project || !operation || !task) return;
		let url = "";
		let state = {};
		if (project?.project_scope === "multi-asset") {
			if (task.operation_id) {
				const _operation = (await getOperations(context.currentTenantKey, {
					_id: task.operation_id,
				})) as TOperationData[];
				url = `/projects/${project.project_code}/${_operation[0].operation_code}/operation-settings`;
				state = {
					tabKey: "well-programme",
					projectCode: project.project_code,
					operationCode: _operation[0].operation_code,
					phaseRecord,
				};
			} else {
				url = `/projects/${project.project_code}/project-settings`;
				state = {
					tabKey: "project-outline",
					project_code: project.project_code,
					phaseRecord,
				};
			}
		} else {
			url = `/projects/${project.project_code}/${operation.operation_code}/operation-settings`;
			state = {
				tabKey: "well-programme",
				projectCode: project.project_code,
				operationCode: operation.operation_code,
				phaseRecord,
			};
		}
		navigate(url, { state });
	};

	return (
		<Button type="link" onClick={handleNavigate} style={{ padding: 0 }}>
			{GetAntIcon("setting")} Task settings
		</Button>
	);
};

export default TaskSettingsButton;
